const API_BASE = import.meta.env.VITE_API_BASE_URL || '';

type Json = any;

// ----- Global loading (for top progress bar) -----
let inFlight = 0;
const listeners = new Set<(n: number) => void>();

function notify() {
  for (const fn of listeners) fn(inFlight);
}

export function subscribeApiLoading(fn: (n: number) => void) {
  listeners.add(fn);
  fn(inFlight);
  return () => { listeners.delete(fn); };
}

async function request<T=Json>(path: string, opts: RequestInit = {}, retry = true): Promise<T> {
  inFlight += 1;
  notify();
  const res = await fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(opts.headers || {})
    },
    credentials: 'include'
  });

  try {
    if (res.status === 204) return undefined as any;

    const data = await res.json().catch(() => ({}));

    if (res.ok) return data as T;

    // token expired -> try refresh once
    if (retry && res.status === 401 && data?.error === 'TOKEN_EXPIRED') {
      const r = await fetch(`${API_BASE}/api/auth/refresh`, { method: 'POST', credentials: 'include' }).catch(() => null);
      if (r && r.ok) return request<T>(path, opts, false);
    }

    const err: any = new Error(data?.message || data?.error || 'Request failed');
    err.status = res.status;
    err.data = data;
    throw err;
  } finally {
    inFlight = Math.max(0, inFlight - 1);
    notify();
  }
}

export const api = {
  get: <T=Json>(path: string) => request<T>(path),
  post: <T=Json>(path: string, body?: any) => request<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  patch: <T=Json>(path: string, body?: any) => request<T>(path, { method: 'PATCH', body: body ? JSON.stringify(body) : undefined })
};
